<template>
  <div>
    <el-button
      type="primary"
      size="mini"
      style="margin-bottom: 20px"
      @click="handleAdd"
      >填报入口开放</el-button
    >
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      height="500px"
      v-loading="loading"
      :header-cell-style="{ background: '#f8f8f8' }"
    >
      <el-table-column
        type="index"
        width="70"
        label="序号"
        align="center"
        :index="indexMethod"
      >
      </el-table-column>
      <el-table-column prop="name" label="资料名称" align="center" />
      <el-table-column prop="ksTime" label="填报开始时间" align="center" />
      <el-table-column prop="endTime" label="填报结束时间" align="center" />

      <el-table-column prop="fileName" label="填报要求" align="center">
        <template slot-scope="scope">
          <div>
            <el-link type="primary" @click="hrefHanler(scope.row)">{{
              scope.row.fileName
            }}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="currentFillNum"
        label="当前填报数量"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <el-link type="primary" @click="current(scope.row)">{{
              scope.row.currentFillNum
            }}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="hanlerEdit(scope.row)">修改</el-button>
          <el-button type="text" @click="hanlerDelete(scope.row.id)"
            >删除</el-button
          >
          <el-button
            type="text"
            @click="hanlerAdd(scope.row)"
            :disabled="scope.row.fillingDisabled"
            >填报</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div ref="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="searchForm.pageNo"
        :limit.sync="searchForm.pageSize"
        @pagination="getList"
      />
    </div>
    <el-dialog
      title="填报入口开放"
      :visible.sync="dialogFormVisible"
      width="35%"
    >
      <el-form :model="form" ref="reset1Ref">
        <el-form-item label="资料名称：" :label-width="formLabelWidth">
          <el-input
            v-model="form.name"
            autocomplete="off"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="填报开始时间：" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.ksTime"
            type="datetime"
            placeholder="请选择开始时间"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="填报结束时间：" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="请选择结束时间"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="填报要求：" :label-width="formLabelWidth">
          <el-upload
            class="upload-demo"
            :action="action"
            ref="upload"
            :data="uploadData"
            :file-list="fileList"
            :before-upload="beforeUpload"
            :headers="headers"
            :on-preview="handlePreviewFile"
            :on-remove="handleRemove"
            :on-success="uploadSuccess"
            :limit="1"
          >
            <el-button class="btn" size="mini">
              <i class="el-icon-paperclip"></i>
              上传附件
            </el-button>
            <div slot="tip" class="el-upload__tip" style="color: #e61d1d">
              提示：最大可上传100mb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="资料填报" :visible.sync="dialogFormVisible1" width="35%">
      <el-form :model="form1" ref="reset2Ref">
        <el-form-item label="资料名称：" :label-width="formLabelWidth">
          <el-input
            disabled
            v-model="form1.name"
            autocomplete="off"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="填报开始时间：" :label-width="formLabelWidth">
          <el-date-picker
            disabled
            v-model="form1.ksTime"
            type="datetime"
            placeholder="请选择开始时间"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="填报结束时间：" :label-width="formLabelWidth">
          <el-date-picker
            disabled
            v-model="form1.endTime"
            type="datetime"
            placeholder="请选择结束时间"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="请上传相关资料：" :label-width="formLabelWidth">
          <el-upload
            class="upload-demo"
            :action="action1"
            ref="upload"
            :data="uploadData1"
            :file-list="fileList1"
            :before-upload="beforeUpload"
            :headers="headers"
            :on-preview="handlePreviewFile1"
            :on-remove="handleRemove1"
            :on-success="uploadSuccess1"
            :limit="1"
          >
            <el-button class="btn" size="mini">
              <i class="el-icon-paperclip"></i>
              上传附件
            </el-button>
            <div slot="tip" class="el-upload__tip" style="color: #e61d1d">
              提示：最大可上传100mb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel1">取 消</el-button>
        <el-button type="primary" @click="submit1">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDataReviewItemAdd,
  addDataReview,
  getDataReview,
  editDataReview,
  delDataReview,
} from "@/api/api.js";
import axios from "axios";
import baseURL from "@/api/baseUrl.js";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      searchForm: {
        pageNo: 1,
        pageSize: 20,
      },
      total: 1,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      form: {
        fillRequirements: "",
        currentFillNum: 0,
        name: "",
        ksTime: "",
        endTime: "",
      },
      form1: {
        fileId: "",
        currentFillNum: 0,
        name: "",
        ksTime: "",
        endTime: "",
        status: "",
      },
      formLabelWidth: "130px",
      action: baseURL + "/sysFileInfo/upload",
      action1: baseURL + "/sysFileInfo/upload",
      fileList: [],
      fileList1: [],
      uploadData: {},
      uploadData1: {},
      headers: { Authorization: "Bearer " + sessionStorage.getItem("token") },
      isShow: false,
      formInline: {
        pageNo: 1,
        pageSize: 10,
        dataId: null,
        status: "",
      },
    };
  },
  created() {
    this.getList();
  },
  props: {
    active: {
      type: String,
    },
  },
  methods: {
    indexMethod(index) {
      return (
        (this.searchForm.pageNo - 1) * this.searchForm.pageSize + index + 1
      );
    },
    async getList() {
      this.loading = true;

      getDataReview().then((res) => {
        this.loading = false;
        if (res.data.code == 200) {
          let { totalRows, rows } = res.data.data;
          console.log(res.data.data);
          var _this = this;
          let yy = new Date().getFullYear();
          let mm = new Date().getMonth() + 1;
          let dd = new Date().getDate();
          let hh = new Date().getHours();
          let mf =
            new Date().getMinutes() < 10
              ? "0" + new Date().getMinutes()
              : new Date().getMinutes();
          let ss =
            new Date().getSeconds() < 10
              ? "0" + new Date().getSeconds()
              : new Date().getSeconds();
          _this.gettime =
            yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
          for (let i = 0; i < rows.length; i++) {
            console.log(_this.gettime > rows[i].endTime);
            if (_this.gettime > rows[i].endTime) {
              rows[i].fillingDisabled = true;
            } else {
              rows[i].fillingDisabled = false;
            }

            this.total = totalRows;
            this.tableData = rows;
            // this.formInline.dataId = rows[i].id;
            // const res1 = await getdataReviewItem(this.formInline);
            // console.log(res1);
          }

          // console.log(res1);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    hrefHanler(row) {
      // 在 node.js 用GET请求获取远程图片
      axios({
        method: "get",
        url: baseURL + "/sysFileInfo/download?id=" + row.fillRequirements,
        responseType: "blob",
      }).then((res) => {
        const data = res.data;
        const url = window.URL.createObjectURL(
          new Blob([data], {
            type: "application/msword",
          })
        );
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.setAttribute("download", row.fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // this.dialogInfo.dialogVisible = false;
      });
    },
    handleAdd() {
      this.reset();
      this.dialogFormVisible = true;
    },
    hanlerEdit(row) {
      this.fileList = [];
      this.dialogFormVisible = true;
      this.form.name = row.name;
      this.form.ksTime = row.ksTime;
      this.form.endTime = row.endTime;
      this.form.id = row.id;
      this.form.currentFillNum = row.currentFillNum;
      this.form.fillRequirements = row.fillRequirements;
      this.fileList.push({
        name: row.fillRequirements,
      });
    },
    reset() {
      // this.$refs.reset1Ref.resetFields();
      this.form = {
        fillRequirements: "",
        currentFillNum: 0,
        name: "",
        ksTime: "",
        endTime: "",
      };
      this.fileList = [];
    },
    reset1() {
      // this.$refs.reset2Ref.resetFields();
      this.form1 = {
        fillRequirements: "",
        currentFillNum: 0,
        name: "",
        ksTime: "",
        endTime: "",
      };
      this.fileList1 = [];
    },
    hanlerDelete(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delDataReview({ id }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          } else {
            this.$message.error(res.data.message);
          }
        });
      });
    },

    beforeUpload(file) {
      if (file.type != "" || file.type != null || file.type != undefined) {
        //截取文件的后缀，判断文件类型
        const FileExt = file.name.replace(/.+\./, "").toLowerCase();
        //计算文件的大小
        const isLt5M = file.size / 1024 / 1024 < 100; //这里做文件大小限制

        //如果大于50M
        if (!isLt5M) {
          this.$message.error("上传文件大小不能超过 100MB!");
          return false;
        }
      }
    },

    handlePreviewFile(file) {
      window.open(file.url);
    },
    handlePreviewFile1(file) {
      window.open(file.url);
    },
    handleRemove(file) {
      this.isShow = false;
      this.form.fillRequirements = "";
    },
    handleRemove1(file) {
      this.isShow = false;
      this.form1.fillRequirements = "";
    },
    uploadSuccess(file) {
      this.form.fillRequirements = file.data;
      this.isShow = true;
    },
    uploadSuccess1(file) {
      this.form1.fileId = file.data;
      this.isShow = true;
    },
    hanlerAdd(row) {
      this.dialogFormVisible1 = true;

      this.form1.name = row.name;
      this.form1.ksTime = row.ksTime;
      this.form1.endTime = row.endTime;

      this.form1.dataName = row.name;
      this.form1.dataId = row.id;
    },
    submit() {
      // console.log(this.fileList);
      if (!this.form.id) {
        addDataReview(this.form).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("新增成功");
            this.getList();
            this.dialogFormVisible = false;
            this.reset();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        editDataReview(this.form).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("修改成功");
            this.getList();
            this.dialogFormVisible = false;
            this.reset();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    async submit1() {
      console.log(this.form1);
      try {
        await getDataReviewItemAdd(this.form1);
        this.$message.success("新增成功");
        this.cancel1();
        this.getList();
      } catch (e) {}
    },
    cancel() {
      this.reset();
      this.dialogFormVisible = false;
    },
    cancel1() {
      this.reset1();
      this.dialogFormVisible1 = false;
    },
    current(row) {
      this.$emit("update:active", row.id);
    },
  },
};
</script>

<style scoped>
::v-deep .pagination-container .el-pagination {
  right: 10px;
  position: absolute;
  bottom: 10px;
}
</style>
